// Último recurso: error de render fuera del router (las rutas tienen su `errorElement`).
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { t } from '@/lib/i18n/es-AR';

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Error de la interfaz', error, info.componentStack);
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-bg px-4 text-center">
        <h1 className="m-0 text-h2 text-ink">{t.serverError.title}</h1>
        <p className="m-0 max-w-[46ch] text-body text-muted">{t.serverError.description}</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-2 h-9 rounded-sm bg-primary px-3.5 text-body font-medium text-on-primary hover:bg-primary-hover"
        >
          {t.serverError.reload}
        </button>
      </div>
    );
  }
}
